import { render, staticRenderFns } from "./mo-date-year-wrapper.html?vue&type=template&id=19e3f775&external"
import script from "./mo-date-year-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-date-year-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-date-year-wrapper.vue?vue&type=style&index=0&id=19e3f775&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/2/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19e3f775')) {
      api.createRecord('19e3f775', component.options)
    } else {
      api.reload('19e3f775', component.options)
    }
    module.hot.accept("./mo-date-year-wrapper.html?vue&type=template&id=19e3f775&external", function () {
      api.rerender('19e3f775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-date-year-wrapper/mo-date-year-wrapper.vue"
export default component.exports